<template>
  <div class="q-pa-lg">
    <session-starter
      v-if="!sessionId"
      :platform="platform"
      v-model:session-id="sessionId"
    />
    <login
      v-else-if="sessionId && !error"
      :session-id="sessionId"
      :platform="platform"
      @error="onError"
      @success="onLogin"
    />
    <message v-else type="warning">
      A problem occurred while logging in to {{ platform }}.
      A member of our support team will contact you by email shortly to
      help you import your {{ platform }} posts.
    </message>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  SessionStarter,
  terminateSession,
  Login,
} from '@/remote-browser';
import Message from '@/components/message/Message.vue';
import { newBroadcastChannel } from '../../../messaging';
import { LoginSuccessful, LoginError } from '.';

interface Data {
  task: Promise<number>|null,
  sessionId: number|null,
  error: boolean
}

export default defineComponent({
  components: {
    SessionStarter,
    Login,
    Message,
  },
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      sessionId: null,
      error: false,
    };
  },
  methods: {
    terminateSession(): void {
      if (!this.sessionId) return;
      terminateSession(this.sessionId);
    },
    onLogin() {
      if (!this.sessionId) return;
      const bc = newBroadcastChannel();
      bc.postMessage(new LoginSuccessful(this.platform, this.sessionId));
      bc.close();
      window.removeEventListener('beforeunload', this.terminateSession);
      window.close();
    },
    onError() {
      this.error = true;
      const bc = newBroadcastChannel();
      bc.postMessage(new LoginError(this.platform));
      bc.close();
      window.removeEventListener('beforeunload', this.terminateSession);
    },
  },
  mounted(): void {
    window.addEventListener('beforeunload', this.terminateSession);
  },
});
</script>
